import { gql } from '@apollo/client';

export const ADD_PERSON_MUTATION = gql(/* GraphQL */ `
    mutation AddPerson(
        $firstName: String!
        $middleName: String
        $lastName: String!
        $jobTitle: String
        $email: String!
        $role: PersonRole!
        $companyId :UUID
        $startDate: DateTime!
        $locationIds: [UUID!]
    ) {
        addPerson(input: {
            firstName: $firstName,
            middleName: $middleName
            lastName: $lastName,
            jobTitle: $jobTitle,
            email: $email,
            companyId:$companyId
            locationIds:$locationIds
            userRole: $role,
            startDate: $startDate
        }) {
            __typename
            person {
                id
                companyId
                firstName
                lastName
                createdAt
                company {
                id
                createdAt
                }
            }
            errors {
                __typename
                ... on ValidationError {
                    errors {
                        fieldName
                        messages
                    }
                }
                ... on EntityNotFoundError {
                    id
                    message
                }
                ... on UnknownError {
                    message
                }
            }
        }
    }
`);